export const L10N = {
  LABEL_MAX: { id: 'common.label.max' },
  LABEL_MIN: { id: 'common.label.min' },
};
